import cn from 'classnames';
import { HTMLAttributes } from 'react';
import styles from './card.module.scss';


export function CardHeader ({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
    return (
        <div
            className={ cn(styles.header, className) }
            data-template="card-header"
            { ...props }
        />
    );
}
